import { standardId } from '../utils/standardRef'

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'

// URL for a standard's source PDF. `standard` is the Standard id.
export function standardPdfUrl(standard) {
  const id = standardId(standard)
  if (!id) return ''
  return `${BASE_URL}/pdfs/${encodeURIComponent(id)}`
}
